import { Component, OnInit, OnDestroy, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { PaymentMethod, Payment, BookedTrip } from '@ibe/models';
import { PaymentService } from './payment.service';
import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import * as BookedTripActions from '../../../store/actions/booked-trip.actions';
// import { FormGroup } from '@angular/forms';
import { SidebarService } from '@ibe/services/ui';

import { INDRAPaymentMethodCardComponent } from './payment-method-card/payment-method-card.indra.component';
import { DataUserPayment } from '@ibe.models/payment_method.model';
import { BrowserInfo } from '@ibe.models/payment_creditcard.model';
import { SESSION_VAR_KEY_PAYMENT_SESSION_ID, PAYMENT_CC_TYPE_OCP, PAYMENT_POC } from '@ibe.config';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-payment',
	templateUrl: './payment.indra.component.html',
	styleUrls: ['./payment.component.scss']
})

export class INDRAPaymentComponent implements OnInit, OnDestroy, OnChanges {
	isAlive = true;
	// form: FormGroup;
	acceptedTermsAndConditions: boolean = false;
	acceptedSendUserInfo: boolean = false;

	@ViewChild(INDRAPaymentMethodCardComponent) paymentMethod: INDRAPaymentMethodCardComponent;

	paymentMethods;

	/** Payment methods to show (all by default) */
	@Input()
	availablePaymentMethods: Array<PaymentMethod> = [
		'credit_card',
		'debit_card',
		'multibanco',
		'mb_way',
		'paypal',
		'alipay',
		'bank_transfer',
		'pickup',
		'klarna_pay_now',
		'klarna_pay_later',
		'bancontact',
		'ideal',
		'multicaixa',
		'poli',
		'caixa_loterias',
		'bank_transfer_br'
	];

	/** First one by default */
	@Input()
	selected_method: PaymentMethod;

	// allSubscriptions: Subscription[] = [];
	// formValiliditySubscription: Subscription;
	// submitSubscription: Subscription;

	@Input()
	disabledPaymentMethods: Array<PaymentMethod> = [];

	@Input()
	disabledTooltipMessage: string;

	@Input()
	hasMilesPayable: boolean;

	@Input()
	displayCovidTermsAndCondition: boolean;

	// For mobile select element
	cardOptions = [];

	enabledPaymentMethods: Array<PaymentMethod> = [];

	displayPaymentPOC: boolean = false;
	hasPaymentMethodRestrictions: boolean = false;
	removedPaymentMethodRestrictions: boolean = false;
	hasPaymentError: boolean = false;

	isScreenMobileTabletPortrait$: Observable<any> = this.store.select(fromStore.isScreenMobileTabletPortrait);
	isScreenMobileTabletPortrait: boolean = false;
	isIE = /*@cc_on!@*/false || !!document['documentMode'];

	booking_trip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booking_trip: BookedTrip;

	extras$: Observable<Array<any>> = this.store.select(fromStore.getSelectedBookedTripExtras);
	extras: Array<any> = [];
	hasPartnerHotelExtra: boolean = false;

	recover_insurance$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripRecoverInsurance);
	recover_insurance: null;

	currency;

	constructor(private paymentService: PaymentService,
		private store: Store<fromStore.State>,
		private sidebarService: SidebarService,
		private storage: INDRAStorageService,
		private currencyService: INDRACurrencyService,
		private bookingPaymentService: INDRAPaymentService,
		protected ibeAdminService: INDRAIbeAdminService) {

		this.isScreenMobileTabletPortrait$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isScreenMobileTabletPortrait = value;
			});

		this.paymentMethods = this.paymentService.paymentMethods;
		this.currency = this.currencyService.INDRA_getCurrencySymbol().name;

		this.displayPaymentPOC = PAYMENT_POC;
	}

	ngOnInit() {
		this.INDRA_getPaymentMethodsMobile();

		this.booking_trip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(trip => {
				if (trip) {
					this.booking_trip = trip;

					if (trip.insurance) {
						this.hasPaymentMethodRestrictions = true;
					} else {
						this.hasPaymentMethodRestrictions = false;
					}
				}
			});

		this.extras$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.extras = value;
					const hotels = this.extras.find(extra => extra.type === 'hotel');
					this.hasPartnerHotelExtra = (hotels && hotels.data && hotels.data.length > 0) ? true : false;
				} else {
					this.hasPartnerHotelExtra = false;
				}
			});

		// Set default selected payment method
		this.paymentService.setSelectedMethod(this.selected_method);


		this.recover_insurance$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(insurance => {
				if (insurance && insurance.length) {
					this.recover_insurance = insurance;
					this.removedPaymentMethodRestrictions = true;
				} else {
					this.recover_insurance = null;
					this.removedPaymentMethodRestrictions = false;
				}
			});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.availablePaymentMethods &&
			changes.availablePaymentMethods.currentValue !== changes.availablePaymentMethods.previousValue) {
			this.enabledPaymentMethods = this.availablePaymentMethods.filter(fop => !this.disabledPaymentMethods.includes(fop));
			this.INDRA_getPaymentMethodsMobile();

			if (this.enabledPaymentMethods.length) {
				this.selected_method = this.enabledPaymentMethods[0];
				this.paymentService.setSelectedMethod(this.selected_method);

			} else {
				this.selected_method = null;
				this.paymentService.setSelectedMethod(null);
			}

		}
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_getGridStyle() {
		const COUNT_METHODS = this.availablePaymentMethods.length;
		let gridSize = 0;
		if (COUNT_METHODS <= 7 && COUNT_METHODS >= 4) {
			gridSize = COUNT_METHODS;
		} else if (COUNT_METHODS < 4) {
			gridSize = 4;
		} else {
			if (COUNT_METHODS % 4 == 0) {
				gridSize = 4;
			} else if (COUNT_METHODS % 5 == 0) {
				gridSize = 5;
			} else if (COUNT_METHODS % 6 == 0) {
				gridSize = 6;
			} else if (COUNT_METHODS % 7 == 0) {
				gridSize = 7;
			} else {
				gridSize = 6;
			}
		}

		return { 'grid-template-columns': 'repeat(' + gridSize + ', 1fr)' };
	}

	INDRA_getMethodStyles(method) {
		const style = {
			'is-selected': method === this.selected_method,
			'is-disabled': this.disabledPaymentMethods.includes(method)
		};

		// to prevent multiple/continuous verbose warnings on console
		return Object.entries(style).filter(cur => cur[1]).map(cur => cur[0]).join(' ');
	}

	INDRA_selectPaymentMethod(method) {
		if (this.disabledPaymentMethods.includes(method)) {
			return false;
		}
		if (this.selected_method !== method) {
			this.paymentService.setFormIsValid(false);
		}
		this.selected_method = method;
		this.paymentService.setSelectedMethod(this.selected_method);
	}

	INDRA_printSelectedPaymentMethodIcon() {
		return this.selected_method !== null ? 'sprite.svg#payment_method--' + this.paymentMethods[this.selected_method].image : 'icons.svg#money_related--payment';
	}

	INDRA_handleRemoveInsurance() {
		// TODO implement this with actual logic
		const reinstateInsurance = JSON.parse(JSON.stringify(this.booking_trip.insurance));
		this.booking_trip = Object.assign(new BookedTrip(null, null, null), this.booking_trip, { insurance: false });
		this.store.dispatch(new BookedTripActions.PutBookedTripAction(this.booking_trip));
		this.store.dispatch(new BookedTripActions.PutBookedTripInsuranceAction(reinstateInsurance));
	}

	INDRA_acceptTermsAndConditionsChange(event) {
		this.acceptedTermsAndConditions = event.target.checked;
		this.INDRA_updateFormValidation();
	}

	INDRA_acceptSendUserInfo(event) {
		this.acceptedSendUserInfo = event.target.checked;
		this.INDRA_updateFormValidation();
	}

	INDRA_updateFormValidation() {
		// TODO implement this with actual logic
		if (this.acceptedTermsAndConditions) {
			const paymentInfo: Payment = {
				name: '',
				time: new Date(),
				status: 'pending',
				method: this.paymentService.getSelectedMethod()
			};
			this.paymentService.setPaymentInfo(paymentInfo);
			this.paymentService.setFormIsValid(true);
		} else {
			this.paymentService.setPaymentInfo(null);
			this.paymentService.setFormIsValid(false);
		}
	}

	INDRA_insuranceAdd() {
		// TODO implement this with actual logic
		const reinstateInsurance = JSON.parse(JSON.stringify(this.recover_insurance));
		this.booking_trip = Object.assign(new BookedTrip(null, null, null), this.booking_trip, { insurance: reinstateInsurance });
		this.store.dispatch(new BookedTripActions.PutBookedTripAction(this.booking_trip));
		this.store.dispatch(new BookedTripActions.PutBookedTripInsuranceAction(null));
	}

	INDRA_FormValue(payment_type): any {
		switch (payment_type) {
			case PAYMENT_CC_TYPE_OCP:
				return this.paymentMethod.INDRA_FormValueOneClickPayment();
			case this.paymentMethods.credit_card.id || this.paymentMethods.debit_card.id || this.paymentMethods.bancontact.id:
				// normal credit card payment
				return this.paymentMethod.INDRA_FormValue();
			default:
				return this.paymentMethod.INDRA_FormValue();
		}
	}

	INDRA_handleBookingTicketConditions() {
		this.sidebarService.openSidebar(['booking-ticket-conditions']);
	}

	public INDRA_getPaymentMethodsMobile() {
		// Fill mobile select element
		this.availablePaymentMethods.forEach(availablePaymentMethod => {
			// If not disabled add to select
			if (!this.disabledPaymentMethods.includes(availablePaymentMethod)) {
				const PAYMENT_METHOD = this.paymentMethods[availablePaymentMethod];
				const PAYMENT_METHOD_LABEL = PAYMENT_METHOD.details ? PAYMENT_METHOD.label + ' (' + PAYMENT_METHOD.details + ')' : PAYMENT_METHOD.label;
				if (this.cardOptions && this.cardOptions.length > 0) {
					if(this.cardOptions.map(option=> { return option.value; }).indexOf(PAYMENT_METHOD.id) == -1){
						this.cardOptions.push(
							{ value: PAYMENT_METHOD.id, image: PAYMENT_METHOD.image, label: PAYMENT_METHOD_LABEL }
						);
					}
				} else {
					this.cardOptions.push(
						{ value: PAYMENT_METHOD.id, image: PAYMENT_METHOD.image, label: PAYMENT_METHOD_LABEL }
					);
				}
			}
		});
	}

	INDRA_paymentMethods(paymentMethod): any {
		switch (paymentMethod) {
			case 'Credit card':
				return this.INDRA_getTranslation('bookingPayment.title.creditCard');
			case 'Debit card':
				return this.INDRA_getTranslation('bookingPayment.title.debitCard');
			case 'Bank Transfer':
				return this.INDRA_getTranslation('bookingPayment.title.bankTransfer');
			default:
				return paymentMethod;
		}
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
}
